import React, { PropTypes } from 'react';
import R from 'ramda';
import LinkPreview from '../../linkPreview';
import FilePreview from '../../../extra/filePreview/container';

const GeneralPost = (props) => {
  const {
    post,
    metadata,
    displayType,
    postFilePreview,
    postFiles,
  } = props;

  const isNilOrEmpty = R.either(R.isEmpty, R.isNil);

  const metaForFirstLink = () => {
    if (!isNilOrEmpty(metadata)) {
      const firstLinkMetadata = R.path([0, 'metadata'], metadata);
      if (firstLinkMetadata) {
        // const firstLinkTwitter = R.propOr({}, 'twitter', firstLinkMetadata);
        const firstLinkOG = R.propOr({}, 'og', firstLinkMetadata);
        return ({
          title: firstLinkOG.title || '',
          description: firstLinkOG.description || '',
          imageUrl: R.pathOr('', ['image', 'url'], firstLinkOG),
          url: firstLinkOG.url || '',
          type: firstLinkOG.type || '',
          siteName: firstLinkOG.siteName || '',
        });
      }
    }
  };

  return (
    <div style={{ clear: 'both' }}>
      {!isNilOrEmpty(metaForFirstLink()) && <LinkPreview {...metaForFirstLink()}/>}
      {
        !isNilOrEmpty(post.files) &&
          <div>
            <FilePreview files={post.files} showCaption={false} showGallery displayType={displayType} postFilePreview={postFilePreview} postPreviewFiles={postFiles} />
          </div>
      }
    </div>
  );
};

GeneralPost.propTypes = {
  post: PropTypes.object,
  metadata: PropTypes.array,
  displayType: PropTypes.string,
  postFilePreview: PropTypes.object,
  postFiles: PropTypes.array,
};

export default GeneralPost;



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/mainFeed/postTypes/general.jsx